import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../api/';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
  selector: 'users-favorites-count',
  templateUrl: './users-favorites-count.component.html',
  styleUrls: ['./users-favorites-count.component.css']
})
export class UsersFavoritesCountComponent {
  @Input() item: any;
  @Input() aboveTooltip: string = 'below';
  dialogRef: MdDialogRef<UserFavouriteDialog>;

  constructor(public dialog: MdDialog) {

  }

  public openUserLikesDialog(event) {
    event.stopPropagation();
    event.preventDefault();
    this.dialogRef = this.dialog.open(UserFavouriteDialog, {
      disableClose: false,
      width: '600px'
    });
    this.dialogRef.componentInstance.item = this.item;
  }

}


@Component({
  selector: 'user-favourite-dialog',
  templateUrl: './user-favourite-dialog.html',
})
export class UserFavouriteDialog implements OnInit {
  public item: any;
  private usersLiked = new Array<any>();
  public onlineOffline1: boolean = navigator.onLine;

  constructor(public dialogRef: MdDialogRef<UserFavouriteDialog>, private userService: UserService, private cdRef: ChangeDetectorRef) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});

  }

  ngOnInit() {
    let domain = this.item._type.substring(0, 1);
    if(this.onlineOffline1){
      this.userService.getUserLikes(domain, this.item.id).then((res) => {
      if (res.length === 0) {
        return [];
      }
      return this.userService.getAccountByIds(res).toPromise();
    }).then((accounts: any) => {
      this.usersLiked = accounts;
      this.cdRef.detectChanges();
    });
  }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/users-favorites-count/users-favorites-count.component.ts